import React, { useMemo } from "react";
import { useTable, useExpanded } from "react-table";
// import { FormControlLabel } from "@material-ui/core";
// import { CustomCheckbox } from "../../customComponent/CustomCheckbox";
import PropTypes from "prop-types";
/* eslint-disable no-unused-vars */

const SalesOrderTable = ({ saleOrder, handleSelectCheck, an8,invoiceActived }) => {
  
  const columns = useMemo(
    () => [
      // {
      //   id: "selection",
      //   isVisible: true,

      //   Cell: (propsCells) => {
      //     const rowIdx = propsCells.row.id;
      //     console.log("invoiced active", invoiceActived);
      //     return (
      //       <div className="col-12 d-flex flex-row">
      //         <FormControlLabel
      //           className="w-100 ms-2 me-0"
      //           control={
      //             <CustomCheckbox
      //               className=" ps-0 ms-0"
      //               color="primary"
      //               onChange={() =>
      //                 handleSelectCheck(
      //                   { ...saleOrder[rowIdx], isChecked: false },
      //                   rowIdx
      //                 )
      //               }
      //               checked={invoiceActived?.salesOrderNumber === saleOrder[rowIdx].salesOrderNumber }
      //               indeterminate={invoiceActived?.active === "false"}
      //             />
      //           }
      //         />
      //       </div>
      //     );
      //   },
      // },
      {
        Header: "Cliente",
        accessor: "an8",
      },
      {
        Header: "Fecha solicitada",
        accessor: "requestedDate",
      },
      {
        Header: "T. Orden Venta",
        accessor: "orderSale",
        maxWidth: 180,
        minWidth: 180,
        width: 180,
      },
      {
        Header: "Num. Orden Venta",
        accessor: "salesOrderNumber",
        maxWidth: 180,
        minWidth: 180,
        width: 180,
      },
      {
        Header: "O. Venta",
        accessor: "sale",
        maxWidth: 180,
        minWidth: 180,
        width: 180,
      },
      {
        Header: "Planta",
        accessor: "plant",
      },
      {
        Header: "T. cemento",
        accessor: "cement",
      },
      {
        Header: "TN",
        accessor: "tn",
      },
      {
        Header: "Estado",
        accessor: "status",
        maxWidth: 180,
        minWidth: 180,
        width: 180,
      },
      {
        Header: "Remisión",
        accessor: "remission",
      },
      {
        Header: "Factura",
        accessor: "numberTypeInvoice",
      },
      {
        Header: "Prog / Comp",
        accessor: "prog_comp",
      },
      {
        Header: "Bloq.",
        accessor: "blocking",
      },
      {
        Header: "Fecha / Hora",
        accessor: "date_hour",
      },
    ],
[]
  );
  
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data: saleOrder,
      },
      useExpanded
    );

  return (
    <table className="table-order" {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup, i) => (
          <tr
            {...headerGroup.getHeaderGroupProps()}
            className="border-content sticky-header"
            key={i}
          >
            {headerGroup.headers.map((column, j) => (
              <th
                {...column.getHeaderProps()}
                className="border-element header-element header-text pt-3 pb-3"
                key={j}
              >
                {column.render("Header")}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <React.Fragment key={row.getRowProps().key}>
              <tr className="element-row border-content">
                {row.cells.map((cell, i) => {
                  return (
                    <td
                      onClick={() => console.log("hola fro the cellcd")}
                      className="border-element content-text pt-2 pb-2"
                      {...cell.getCellProps()}
                      key={i}
                    >
                      {cell.column.id === "an8"
                        ? an8
                        : cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  );
};

SalesOrderTable.propTypes={
  saleOrder: PropTypes.any, 
  handleSelectCheck: PropTypes.func,
  an8: PropTypes.string || PropTypes.number,
  invoiceActived: PropTypes.any
}

export default SalesOrderTable;
